import React, {useState} from "react";
import {IonButton, IonContent, IonInput, IonItem, IonLabel, IonLoading, IonPage} from "@ionic/react";
import fb from 'lib/firebase';
import {version} from "config";
import {actions} from "lib/app";
import PasswordInput from "components/PasswordInput";
import styles from './Login.module.css';
import {useAppDispatch} from "lib/hooks";
import NovoCadastro from "./NovoCadastro";


const Login: React.FC = () => {
  const dispatch = useAppDispatch();
  const [login, setLogin] = useState<string>('');
  const [senha, setSenha] = useState<string>('');
  const [enviando, setEnviando] = useState(false);
  const [cadastroIsOpen, setCadastroIsOpen] = useState(false);

  const onChangeLogin = (e:any) => {
    setLogin(e.target.value);
  };

  const onChangeSenha = (senha: string) => {
    setSenha(senha);
  };

  const onClickEntrar = async () => {
    setEnviando(true);
    try {
      await fb.auth.signInWithEmailAndPassword(login, senha);
    } catch (error: any) {
      console.log("DEBUG erro firebase auth:", error);

      let mensagem = "Erro ao fazer login.";

      switch (error.code) {
        case "auth/invalid-credential":
        case "auth/wrong-password":
        case "auth/user-not-found":
          mensagem = "Email ou senha incorretos.";
          break;

        case "auth/too-many-requests":
          mensagem = "Muitas tentativas de login. Tente novamente em alguns minutos.";
          break;

        default:
          mensagem = "Não foi possível fazer login. Tente novamente.";
      }

      dispatch(actions.notifyError(mensagem));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <IonPage>
      <IonContent>
        <div className={`${styles.fundo} h-screen`}>
          <div className={`${styles.logo}`}/>
          <div className={`${styles.rodape}`}/>
          <div className="container mx-auto h-full flex justify-center items-center">
            <div className="w-10/12 lg:w-1/2">
              <div className={`px-2 pt-2 pb-2 rounded-lg shadow-lg ${styles.inputs}`}>
                <IonItem>
                  <IonLabel position="floating">Email</IonLabel>
                  <IonInput
                    value={login}
                    onIonChange={onChangeLogin}
                    type="email"
                    inputmode="email"
                  />
                </IonItem>
                <PasswordInput
                  onChange={onChangeSenha}
                  value={senha}
                />

                <div className="mt-10 w-full">
                  <IonButton
                    expand="block"
                    onClick={onClickEntrar}
                    disabled={!login || !senha}
                  >
                    Entrar
                  </IonButton>
                </div>

                <div className="mt-4">
                  <IonButton
                    fill="clear"
                    size="small"
                    expand="block"
                    onClick={() => setCadastroIsOpen(true)}
                  >
                    Quero me cadastrar
                  </IonButton>
                </div>

                <div className="mt-4 text-center text-gray-400 text-sm">
                  v{version}
                </div>
              </div>
            </div>
          </div>
        </div>

        <IonLoading
          isOpen={enviando}
          message={'Aguarde...'}
        />

        <NovoCadastro
          isOpen={cadastroIsOpen}
          onDidDismiss={() => setCadastroIsOpen(false)}
        />
      </IonContent>
    </IonPage>
  );
}

export default Login;